import type { CarrierCarrierSummaryResponse } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const carrierSummaries = {
  search: {
    queryKey: 'carrier-service/carrier-summaries',
    configurationType: 'cached' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<CarrierCarrierSummaryResponse>(
        '/sim-carrier-proxy/api/v1/carriers/summary',
      );

      return data;
    },
  },
};
